










































import { Vue, Component, Watch } from 'vue-property-decorator';
import { Button } from 'vant';
import { baseInfo } from '../api/index';
import AliPayButton from '@/components/AliPayButton.vue';
import { getLocalTime, nowInDateBetwen } from '../util/index';

@Component({
  components: {
    Button,
    AliPayButton,
  },
})
export default class TopUp extends Vue {
  amountArr: any[] = [
    {
      id: 1,
      money: 10,
    },
    {
      id: 2,
      money: 20,
    },
    {
      id: 3,
      money: 50,
    },
    {
      id: 4,
      money: 100,
    },
    {
      id: 5,
      money: 200,
    },
    {
      id: 6,
      money: 500,
    },
  ];
  inputMoney: number | string = '';
  username: string = '';
  userid: string = '';
  activeClass = 9;
  money = 0;
  startTime = '';
  endTime = '';
  get topUpMoney() {
    if (this.inputMoney) {
      if (
        this.inputMoney !== 10 &&
        this.inputMoney !== 20 &&
        this.inputMoney !== 50 &&
        this.inputMoney !== 100 &&
        this.inputMoney !== 200 &&
        this.inputMoney !== 500
      ) {
        this.activeClass = 9;
      }

      return Number(this.inputMoney);
    } else if (this.activeClass !== 9) {
      return this.money;
    } else {
      return 0;
    }
  }
  get isCanPay() {
    const isInVoteTime: any = nowInDateBetwen(this.startTime, this.endTime);
    console.log(isInVoteTime);
    if (isInVoteTime.toString() !== 'true') {
      return false;
    } else {
      return true;
    }
  }
  created() {
    baseInfo().then((res: any) => {
      this.startTime = getLocalTime(res.data.startTime);
      this.endTime = getLocalTime(res.data.endTime);
    });
  }
  handleAmountClick(index: number, money: number) {
    this.money = money;
    this.inputMoney = money;

    this.activeClass = index;
    console.log(this.activeClass);
  }
  handleInput(e: any) {
    if (process.env.VUE_APP_ENV_NAME === 'production') {
      e.target.value = e.target.value.replace(/^(0)/g, '');
      e.target.value = e.target.value.replace(/\D/g, '');
    }
  }
  testInput(e: any) {
    if (process.env.VUE_APP_ENV_NAME === 'production') {
      const key = e.data || '';
      if (key === '.') {
        e.preventDefault();
      }
    }
  }
}
